export default "__VITE_ASSET__DFXNeYTK__"